import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
const audience = [{
  title: 'Mujeres que volvieron a entrenar',
  desc: 'Estuviste un tiempo parada por trabajo, maternidad o rutina y querés retomar con un objetivo real.'
}, {
  title: 'Entrenás en casa o en el gym',
  desc: 'Con mancuernas, tu propio peso o acceso a un gimnasio básico te alcanza. Sin equipamiento de élite.'
}, {
  title: 'Mujeres motivadas por HYROX',
  desc: 'Viste HYROX en redes, te generó algo, y querés un sistema que te lleve desde hoy hasta la línea de largada.',
  badge: 'NUEVO'
}, {
  title: 'Buscás resultados que se sostengan',
  desc: 'No querés perder 5 kilos para recuperarlos. Querés fuerza, hábito y una carrera real como meta.'
}];
export function TargetAudience() {
  return <section className="py-24 px-4 bg-brand-dark relative" data-id="element-272">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-copper/30 to-transparent" data-id="element-273" />

      <div className="max-w-5xl mx-auto" data-id="element-274">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-275">
          <h2 className="text-4xl md:text-6xl text-white mb-4" data-id="element-276">
            ¿PARA QUIÉN <span className="text-brand-copper" data-id="element-277">ES?</span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-278">
            Diseñado para vos si querés llegar a HYROX desde donde estás hoy
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-279">
          {audience.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-brand-black p-8 rounded-2xl border border-gray-800 relative overflow-hidden" data-id="element-280">
              {item.badge && <div className="absolute top-4 right-4 bg-brand-pink text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-281">
                  {item.badge}
                </div>}
              <CheckCircle2Icon className="w-8 h-8 text-brand-copper mb-4" data-id="element-282" />
              <h3 className="text-xl text-white font-bold mb-3" data-id="element-283">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-284">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-285">
          <a href="#pricing" className="inline-flex items-center gap-2 text-brand-pink hover:text-white transition-colors font-semibold" data-id="element-286">
            ¿No estás segura si es para vos? Tenés 7 días de garantía{' '}
            <ArrowRightIcon className="w-4 h-4" data-id="element-287" />
          </a>
        </motion.div>
      </div>
    </section>;
}